module.exports = __webpack_public_path__ + "static/media/logo_white.e7a13ae6.svg";